export default __webpack_public_path__ + "static/logo-c928e19d0099c8282173846023bfc6bb.svg";